
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { option_type, list_type, string_type, union_type, record_type, bool_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class OnboardingAvailable extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function OnboardingAvailable_$reflection() {
    return record_type("Shared.Onboarding.OnboardingAvailable", [], OnboardingAvailable, () => [["Value", bool_type]]);
}

export class ImportDemoDataResponse extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Successful", "TestphaseEndOrDemoDataAlreadyImported"];
    }
}

export function ImportDemoDataResponse_$reflection() {
    return union_type("Shared.Onboarding.ImportDemoDataResponse", [], ImportDemoDataResponse, () => [[], []]);
}

export class CompletedOnboardingTourStepsDto extends Record {
    constructor(CompletedSteps) {
        super();
        this.CompletedSteps = CompletedSteps;
    }
}

export function CompletedOnboardingTourStepsDto_$reflection() {
    return record_type("Shared.Onboarding.CompletedOnboardingTourStepsDto", [], CompletedOnboardingTourStepsDto, () => [["CompletedSteps", list_type(string_type)]]);
}

export class CompleteOnboardingTourStepsDto extends Record {
    constructor(Step) {
        super();
        this.Step = Step;
    }
}

export function CompleteOnboardingTourStepsDto_$reflection() {
    return record_type("Shared.Onboarding.CompleteOnboardingTourStepsDto", [], CompleteOnboardingTourStepsDto, () => [["Step", string_type]]);
}

export class SubmitOnboardingWizardDto extends Record {
    constructor(InventoryCategories, OtherCategoryText, NumberOfEmployees, NumberOfTools, WantsOverview, WantsReduceToolLoss, WantsInspections, WantsCostControl, WantsProcessOptimization, WantsInternalCommunication, OtherProblemSelected, OtherProblemText, CurrentSolution, CurrentSolutionOtherText) {
        super();
        this.InventoryCategories = InventoryCategories;
        this.OtherCategoryText = OtherCategoryText;
        this.NumberOfEmployees = NumberOfEmployees;
        this.NumberOfTools = NumberOfTools;
        this.WantsOverview = WantsOverview;
        this.WantsReduceToolLoss = WantsReduceToolLoss;
        this.WantsInspections = WantsInspections;
        this.WantsCostControl = WantsCostControl;
        this.WantsProcessOptimization = WantsProcessOptimization;
        this.WantsInternalCommunication = WantsInternalCommunication;
        this.OtherProblemSelected = OtherProblemSelected;
        this.OtherProblemText = OtherProblemText;
        this.CurrentSolution = CurrentSolution;
        this.CurrentSolutionOtherText = CurrentSolutionOtherText;
    }
}

export function SubmitOnboardingWizardDto_$reflection() {
    return record_type("Shared.Onboarding.SubmitOnboardingWizardDto", [], SubmitOnboardingWizardDto, () => [["InventoryCategories", list_type(string_type)], ["OtherCategoryText", option_type(string_type)], ["NumberOfEmployees", string_type], ["NumberOfTools", string_type], ["WantsOverview", bool_type], ["WantsReduceToolLoss", bool_type], ["WantsInspections", bool_type], ["WantsCostControl", bool_type], ["WantsProcessOptimization", bool_type], ["WantsInternalCommunication", bool_type], ["OtherProblemSelected", bool_type], ["OtherProblemText", option_type(string_type)], ["CurrentSolution", string_type], ["CurrentSolutionOtherText", option_type(string_type)]]);
}

